/**
 * @param {vueInstance} context - This
 * @returns {Section}
 */
export default function (context) {
  const { id } = context.item

  return {
    key: 'leads_heading',
    resource: '',
    type: 'Section',
    title: {
      id: 'project_leads_title',
      label: `${context.$tc('lead', 2)}`,
    },
    border: true,
    actions: [
      {
        id: 'buyers_title',
        label: `${context.$t('showAll')} ${context.$tc('lead', 2).toLowerCase()}`,
        icon: ['fal', 'arrow-to-right'],
        type: 'button',
        tag: 'router-link',
        theme: 'primary',
        to: {
          name: `${context.type}-leads`,
          params: { reference: id },
          query: context.$route.query,
        },
      },
    ],
  }
}
